package common.constants

import androidx.compose.ui.graphics.Color
import common.asset.ImageAsset
import feature.businessMenu.modal.BusinessMenu
import feature.businessMenu.modal.MenuType
import locale.Localization
import locale.localization


class BusinessMenuConfig {
    fun getMenu(): List<BusinessMenu> {
        val firstMenu: ArrayList<BusinessMenu> = arrayListOf()
        firstMenu.add(
            BusinessMenu(
                "sale",
                MenuType.MENU,
                localization().businessMenu.menuLabelSale,
                ImageAsset.saleIcon,
                "business_sale",
                Color(0xFFF5F5D5)
            )
        )
        firstMenu.add(
            BusinessMenu(
                "invoice",
                MenuType.MENU,
                localization().businessMenu.invoice,

                //"Invoice",
                ImageAsset.receiptIcon,
                "business_invoice",
                Color(0xFFE3F5E2)
            )
        )

        val secondMenu: ArrayList<BusinessMenu> = arrayListOf()
        secondMenu.add(
            BusinessMenu(
                "product",
                MenuType.MENU,
                localization().businessMenu.product,
                //"Product",
                ImageAsset.productMenuIcon,
                "business_inventory_product",
                Color(0xFFDEF4F8)
            )
        )
        secondMenu.add(
            BusinessMenu(
                "category",
                MenuType.MENU,
                localization().businessMenu.category, // "Category",
                ImageAsset.categoryMenuIcon,
                "business_inventory_category",
                Color(0xFFE7E7E7)
            )
        )
        secondMenu.add(
            BusinessMenu(
                "sub_category",
                MenuType.MENU,
                localization().businessMenu.subCategory,
                //"Sub Category",
                ImageAsset.subCategoryIcon,
                "business_inventory_sub_category",
                Color(0xFFF9E0F5)
            )
        )
        secondMenu.add(
            BusinessMenu(
                "stock",
                MenuType.MENU,
                localization().businessMenu.stock,
                //"Stock",
                ImageAsset.inventory,
                "business_business_stock",
                Color(0xFFFEF7F3)
            )
        )


        val thirdMenu: ArrayList<BusinessMenu> = arrayListOf()
//        if (!BusinessHandler.shared().repository.business.value.Name.isNullOrEmpty()) {
//            thirdMenu.add(
//                BusinessMenu(
//                    "business",
//                    MenuType.MENU,
//                    BusinessHandler.shared().repository.business.value.Name,
//                    ImageAsset.businessIcon,
//                    "my_business_profile",
//                    Color(0xFFBCDBFF)
//                )
//            )
//        } else {
        thirdMenu.add(
            BusinessMenu(
                "business",
                MenuType.MENU,
                localization().businessMenu.storeLabel,
                //"Store",
                ImageAsset.businessIcon,
                "my_business_store",
                Color(0xFFBCDBFF)
            )
        )
//        }

        thirdMenu.add(
            BusinessMenu(
                "dashboard",
                MenuType.MENU,
                localization().businessMenu.dashboard,
                //"Dashboard",
                ImageAsset.dashboardIcon,
                "business_dashboard",
                Color(0xFFE2F1E9)
            )
        )
        thirdMenu.add(
            BusinessMenu(
                "employee",
                MenuType.MENU,
                localization().businessMenu.employee,
                //"Employee",
                ImageAsset.employeeIcon,
                "business_employee",
                Color(0xFFFFF3E0)
            )
        )
        thirdMenu.add(
            BusinessMenu(
                "customer",
                MenuType.MENU,
                localization().businessMenu.customer,
                //"Customer",
                ImageAsset.customerIcon,
                "business_customers",
                Color(0xFFFDE0DD)
            )
        )
        thirdMenu.add(
            BusinessMenu(
                "all_business",
                MenuType.MENU,
                localization().businessMenu.allBusiness,
                //"All Business",
                ImageAsset.businessIcon,
                "self_business_list",
                Color(0xFFE7E7E7)
            )
        )

        val allMenuItems = listOf(
            BusinessMenu(
                "sale_header",
                MenuType.HEADER,
                localization().businessMenu.sale,
                ImageAsset.shoppingCart,
                "business_sale",
                Color(0xFFF5F5D5)
            ),
            BusinessMenu(
                "sale",
                MenuType.MENU,
                "",
                ImageAsset.shoppingCart,
                "business_sale",
                Color(0xFFffffff),
                firstMenu
            ),
            BusinessMenu(
                "inventory_header",
                MenuType.HEADER,
                localization().businessMenu.inventory,
                ImageAsset.shoppingCart,
                "inventory_product",
                Color(0xFFDEF4F8)
            ),
            BusinessMenu(
                "inventory",
                MenuType.MENU,
                "",
                ImageAsset.shoppingCart,
                "inventory_product",
                Color(0xFFffffff),
                secondMenu
            ),
            BusinessMenu(
                "store_header",
                MenuType.HEADER,
                localization().businessMenu.store,
                ImageAsset.shoppingCart,
                "inventory_product",
                Color(0xFFDEF4F8)
            ),
            BusinessMenu(
                "store",
                MenuType.MENU,
                "",
                ImageAsset.shoppingCart,
                "inventory_product",
                Color(0xFFffffff),
                thirdMenu
            )
        )
        return allMenuItems
    }
}